/**
 * The built-in dictionary (ADR central-data-model): every field and code as
 * the code describes it, before any Admin edit. Everything that should show an
 * Admin's edits reads the EFFECTIVE dictionary instead (effective.ts).
 *
 * The content itself is in ./content — example content a project replaces.
 */
import { codeDefs } from './content/codes.ts'
import { ENTITY_INFO, MAIN_RECORD_TYPES } from './content/entities.ts'
import { fieldDefs } from './content/fields.ts'
import type { CodeDef, DataEntity, FieldDef } from './types.ts'

export { ENTITY_INFO, MAIN_RECORD_TYPES }

export const builtInFields: readonly FieldDef[] = fieldDefs

export const builtInCodes: readonly CodeDef[] = codeDefs

export const fieldId = (entity: DataEntity, key: string) => `${entity}.${key}`
/** `item.status=done` — field keys never contain “=”, so the first one splits it. */
export const codeId = (fieldIdValue: string, value: string) => `${fieldIdValue}=${value}`
export function splitCodeId(id: string): { fieldId: string; value: string } | null {
  const at = id.indexOf('=')
  return at < 0 ? null : { fieldId: id.slice(0, at), value: id.slice(at + 1) }
}

const fieldsById = new Map(builtInFields.map((f) => [fieldId(f.entity, f.key), f]))
export const builtInField = (id: string): FieldDef | undefined => fieldsById.get(id)

/** A built-in label — for code that can't wait for the effective dictionary. */
export function builtInLabel(entity: DataEntity, key: string): string {
  return fieldsById.get(fieldId(entity, key))?.label ?? key
}

/** The fields whose values are codes, in the order the screen lists them. */
export const codedFieldIds: readonly string[] = builtInFields
  .filter((f) => f.kind === 'code')
  .map((f) => fieldId(f.entity, f.key))
